import { gsap } from '/shared.js';


const all_numbers = document.querySelectorAll('.numbers-strip .number')

//Numbers animation
all_numbers.forEach(function (el, ind) {

  //  console.log('animating number:', el);

    const original = el.getAttribute('data-number');
    const val = Number(original);
    const padLength = original.length;

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.numbers.strip',

        }
    });

    var Cont = { val: 0 },
        NewVal = val

    tl.to(Cont, 2, {
        val: NewVal,
        //roundProps: "val",
        onUpdate: function () {
            let displayVal;
            if (Number.isInteger(val)) {
                displayVal = String(Math.ceil(Cont.val)).padStart(padLength, '0');
            } else {
                displayVal = Cont.val.toFixed(1);
            }
            el.innerHTML = displayVal;




        }
    });

})
